import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomeOne from './HomeOne'
import HomeTwo from './HomeTwo'
import HomeThree from './HomeThree'
import HomeFour from './HomeFour'
import HomeFive from './HomeFive'
import HomeSix from './HomeSix'
import HomeBnb from './HomeBnb'
import About from './About'
import LoadTop from '../Components/LoadTop'
import Destination from './Destination'
import DestinationDetails from './DestinationDetails'
import Service from './Service'
import ServiceDetails from './ServiceDetails';
import Activities from './Activities'
import ActivitiesDetails from './ActivitiesDetails'
import Shop from './Shop'
import ShopDetails from './ShopDetails'
import Cart from './Cart'
import Checkout from './Checkout'
import Wishlist from './Wishlist'
import Gallery from './Gallery'
import Tour from './Tour'
import TourDetails from './TourDetails'
import Resort from './Resort'
import ResortDetails from './ResortDetails'
import TourGuide from './TourGuide'
import TourGuiderDetails from './TourGuiderDetails'
import Faq from './Faq'
import Pricing from './Pricing'
import Error from './Error'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import Contact from './Contact'
import Accommodation from './Accommodation'
import DemoHomepage from '../Components/Demo/DemoHomepage'
import BookingPage from './BookingPage';
import CategoryDetails from './CategoryDetails'
import CarHireDetails from './CarHireDetails'
import HotelDetails from './HotelDetails'

function RouterPage() {
  return (
    <div>
      <Router basename="/">
        <LoadTop />
        <Routes>
          <Route path="/" element={<HomeOne />}></Route>
          <Route path="/home-tour" element={<HomeTwo />}></Route>
          <Route path="/home-agency" element={<HomeThree />}></Route>
          <Route path="/home-yacht" element={<HomeFour />}></Route>
          <Route path="/home-ticket" element={<HomeFive />}></Route>
          <Route path="/home-carhire" element={<HomeSix />}></Route>
          <Route path="/home-bnb" element={<HomeBnb />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/booking" element={<BookingPage />}></Route>
          <Route path="/destination" element={<Destination />}></Route>
          <Route path="/destinations" element={<Destination />}></Route>
          <Route path="/destination/:id" element={<DestinationDetails />} />
          <Route path="/service" element={<Service />}></Route>
          <Route path="/service/:id" element={<ServiceDetails />} />
          <Route path="/activities" element={<Activities />}></Route>
          <Route path="/activities-details" element={<ActivitiesDetails />}></Route>
          <Route path="/shop" element={<Shop />}></Route>
          <Route path="/shop/:id" element={<ShopDetails />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/wishlist" element={<Wishlist />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/tour" element={<Tour />}></Route>
          <Route path="/tour/:slug" element={<TourDetails />}></Route>
          <Route path="/tour-details" element={<TourDetails />}></Route>
          <Route path="/resort" element={<Resort />}></Route>
          <Route path="/resort/:id" element={<ResortDetails />}></Route>
          <Route path="/tour-guide" element={<TourGuide />}></Route>
          <Route path="/tour-guide/:id" element={<TourGuiderDetails />}></Route>
          <Route path="/faq" element={<Faq />}></Route>
          <Route path="/price" element={<Pricing />}></Route>
          <Route path="/error" element={<Error />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog/:id" element={<BlogDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/accommodation" element={<Accommodation />}></Route>
          <Route path="/categories/:slug" element={<CategoryDetails />}></Route>
          <Route path="/demo" element={<DemoHomepage />}></Route>
          <Route path="/car-hire" element={<HomeSix />}></Route>
          <Route path="/car-hire/search" element={<HomeSix />}></Route>
          <Route path="/car-hire/cars/:id" element={<CarHireDetails />}></Route>
          <Route path="/hotels" element={<HomeBnb />}></Route>
          <Route path="/hotels/search" element={<HomeBnb />}></Route>
          <Route path="/hotel-booking/:id" element={<HotelDetails />}></Route>
          <Route path="/bnb/:id" element={<HotelDetails />}></Route>
        </Routes>
      </Router>
    </div>
  )
}

export default RouterPage
